import API from './Api';

class PushNotificationsService extends API {
	readNotification = (id) => {
		return this.API.put(`${this.controller}/${id}`);
	};
}

export default new PushNotificationsService('api/notifications');
